import React from "react";
import logo from "../../../../assets/img/logo.png";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { uiAction } from "../../../../Redux/Slices/uiSlice";

const BrandLogo = () => {
    const dispatch = useDispatch();
    const handleToggle = () => {
        dispatch(uiAction.setSideBarToggle())
    }
    return (

        <div className="navbar-logo">
            <button
                className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarTopCollapse"
                aria-controls="navbarTopCollapse"
                aria-expanded="true"
                aria-label="Toggle Navigation"
                onClick={handleToggle}
            >
                <span className="navbar-toggle-icon text-light">
                    <span className="toggle-line text-light" />
                </span>
            </button>
            <Link className="navbar-brand" to="/dashboard">
                <img src={logo} alt="Logo" />
            </Link>
        </div>
    );
}

export default BrandLogo;
